var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3 my-12",attrs:{"fluid":""}},[_c('CheckoutCC',{attrs:{"tableTitle":"Cart Items","tableHeader":_vm.tableHeader,"tableData":_vm.getCart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }